import { useFilterStore, useStateCounts } from "~/components/build/Show/lib/useFilterStore";
import type { FilterByOption } from "~/components/build/Show/lib/filterConstants";

/**
 * Displays a summary of hidden steps when filters are active.
 * Shows "N hidden by filters · Clear filters" at the bottom of the step list.
 */
export function FilterSummary({ filters }: { filters: FilterByOption[] }) {
  const resetFilters = useFilterStore((state) => state.resetFilters);
  const stateCounts = useStateCounts();

  if (filters.length === 0) {
    return null;
  }

  const totalSteps = Object.values(stateCounts).reduce((sum, count) => sum + count, 0);
  const visibleSteps = filters.reduce((sum, filter) => sum + (stateCounts[filter] || 0), 0);
  const hiddenCount = totalSteps - visibleSteps;

  if (hiddenCount <= 0) {
    return null;
  }

  return (
    <div
      className="text-charcoal-400 mt-2 flex items-center justify-center gap-1.5 py-2 text-sm"
      data-testid="filter-summary"
    >
      <span>
        <span className="text-charcoal-600 font-medium">{hiddenCount}</span>{" "}
        <span className="@xs/outlet:!inline hidden">{hiddenCount === 1 ? "step " : "steps "}</span>
        hidden by filters
      </span>
      <span className="text-charcoal-300">·</span>
      <button
        type="button"
        onClick={resetFilters}
        className="text-charcoal-600 hover:text-charcoal-800 font-medium"
      >
        Clear filters
      </button>
    </div>
  );
}
